<template>
  <v-layout column>
    <v-flex>
      <lookup-select
        label="Scope of Practice"
        v-model="item.scopeofpracticeid"
        lookup-name="ScopesOfPractice"
      />
      <v-layout>
        <v-flex sm9>
          <lookup-select
            label="Conditions"
            v-model="item.conditionid"
            lookup-name="ConditionTypes"
          />
        </v-flex>
        <v-flex sm3 class="pl-2">
          <v-checkbox
            v-model="item.isconfidential"
            label="Condition is confidential"
            hint="This will hide the condition from both the Public Register, paper/pdf certificates, and any other public documents"
            persistent-hint
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex sm9>
          <v-textarea v-model="item.comments" label="Comments" auto-grow box />
        </v-flex>
        <v-flex sm3 class="pl-2">
          <v-checkbox
            v-model="item.commentsconfidential"
            label="Only the comments are confidential"
            hint="Only hide the comments."
            persistent-hint
          />
        </v-flex>
      </v-layout>
    </v-flex>
    <v-flex mt-6>
      <v-layout justify-space-between wrap>
        <v-flex sm4>
          <date-picker v-model="item.dateadded" label="Condition Start Date" />
        </v-flex>
        <v-flex sm4>
          <date-picker v-model="item.datemet" label="Date Met" />
        </v-flex>
        <v-flex sm3>
          <v-text-field
            v-model="item.preceptorshipid"
            label="Precepter ID (optional)"
          />
        </v-flex>
      </v-layout>
    </v-flex>
  </v-layout>
</template>

<script>
export default {
  props: {
    item: Object,
    required: true
  }
};
</script>
